export default [
  {
    path: '/login',
    name: 'login',
    meta: { publicPage: true },
    component: () =>
      import(/* webpackChunkName: "login" */ '@/views/Login.vue')
  },
]
